import React from 'react';

export default function ComingSoon() {
  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 p-6 bg-white rounded-xl shadow-md mt-12">
        <div>
          <img
            className="mx-auto h-12 w-auto"
            src="https://consultala.com/static/images/consultala2.png"
            alt="Your Logo"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-700">
            Funzionalità in arrivo
          </h2>
        </div>
        <p className="mt-2 text-center text-md text-gray-600">
          Il nostro team di sviluppo sta lavorando per implementare questa funzionalità il prima possibile.
        </p>
      </div>
    </div>
  );
}